'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmEmailRoute = undefined;

var _WaitingDots = require('components/WaitingDots/WaitingDots');

var _ConfirmEmailOnenter = require('./ConfirmEmail.onenter.saga');

// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};

var ConfirmEmailRoute = exports.ConfirmEmailRoute = function ConfirmEmailRoute(store, client) {
  return {
    path: '/confirm/:key',

    onEnter: function onEnter(nextState, replaceState, cb) {
      return store.runSagaOnce(_ConfirmEmailOnenter.confirmEmailOnEnterSaga, client, nextState, replaceState).done.then(cb, cb);
    },
    component: _WaitingDots.WaitingDots
  };
};